import { getLanguageParam } from '@sportal365/smp-widget-utils';
import { IPlayerInformationResponseData, IPlayerStatisticsResponseData, SDKOptions } from '../../types';
import { generateRequest } from '../http.service';

export const getPlayerInformation = async ({
  id,
  sdkOptions,
}: {
  id: string;
  sdkOptions: SDKOptions;
}): Promise<IPlayerInformationResponseData> => {
  const url = `${sdkOptions.dataConfigApiUrl}/v2/players/${id}`;

  const baseParams = {
    language_code: getLanguageParam(sdkOptions.dataConfigLang),
    optional_data: 'form',
  };

  const requestParams = {
    ...baseParams,
  };

  return await generateRequest(url, requestParams, sdkOptions);
};

export const getPlayerStatistic = async ({
  player_ids,
  season_ids,
  sdkOptions,
}: {
  player_ids?: string;
  season_ids?: string;
  sdkOptions: SDKOptions;
}): Promise<IPlayerStatisticsResponseData> => {
  const url = `${sdkOptions.dataConfigApiUrl}/v2/statistics/players/season`;

  const baseParams = {
    language_code: getLanguageParam(sdkOptions.dataConfigLang),
    player_ids,
    season_ids,
  };

  const requestParams = {
    ...baseParams,
  };

  return await generateRequest(url, requestParams, sdkOptions);
};
